export const CONTACT_LIST_REQUEST = 'CONTACT_LIST_REQUEST'
export const CONTACT_LIST_SUCCESS = 'CONTACT_LIST_SUCCESS'
export const CONTACT_LIST_FAIL = 'CONTACT_LIST_FAIL'
export const CONTACT_LIST_RESET = 'CONTACT_LIST_RESET'

export const CONTACT_DETAIL_REQUEST = 'CONTACT_DETAIL_REQUEST'
export const CONTACT_DETAIL_SUCCESS = 'CONTACT_DETAIL_SUCCESS'
export const CONTACT_DETAIL_FAIL = 'CONTACT_DETAIL_FAIL'
export const CONTACT_DETAIL_RESET = 'CONTACT_DETAIL_RESET'
